export const getAllowStatisticsFrag = `
    serviceId
    key
    isGroup
    enabled
`;
